import styled from 'styled-components';

export const StyledProgressContainer = styled.div`
    ${() => `
    backdrop-filter: blur(2px);
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 50;

    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px;
    `}
`;
